// extracted by mini-css-extract-plugin
export default {"potential-container":"potential_potential-container__G0QpM","filter-wrapper":"potential_filter-wrapper__iYqdB","potentials":"potential_potentials__5Ks7e"};